import React from 'react'
import TextField from 'material-ui/TextField';

const CountDownOptions = ({styles, settings, handleChange}) => {
    return (
      <div><h2>Countdown Options</h2>
        <div className="content">
        <TextField
            floatingLabelText="CountDown End Date"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={settings.countdownEndDate}
            placeholder = '2019-07-17 02:59:59'
            name="countdownEndDate"
            onChange={handleChange}
            style={styles.inputStyle}
          />
          <TextField
            floatingLabelText="CountDown Text1"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={settings.countdownText1}
            name="countdownText1"
            onChange={handleChange}
            style={styles.inputStyle}
          />
          <TextField
            floatingLabelText="CountDown Text2"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={settings.countdownText2}
            name="countdownText2"
            onChange={handleChange}
            style={styles.inputStyle}
          />
          <TextField
            floatingLabelText="Countdown Text3"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={settings.countdownText3}
            name="countdownText3"
            onChange={handleChange}
            style={styles.inputStyle}
          />
          <TextField
            floatingLabelText="Countdown Text1 Mobile"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={settings.countdownText1Mobile}
            name="countdownText1Mobile"
            onChange={handleChange}
            style={styles.inputStyle}
          />
          <TextField
            floatingLabelText="Countdown Text2 Mobile"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={settings.countdownText2Mobile}
            name="countdownText2Mobile"
            onChange={handleChange}
            style={styles.inputStyle}
          />
          <TextField
            floatingLabelText="Countdown Text3 Mobile"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={settings.countdownText3Mobile}
            name="countdownText3Mobile"
            onChange={handleChange}
            style={styles.inputStyle}
          />
          <TextField
            floatingLabelText="Countdown Background Color"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={settings.countdownBackgroundColor}
            name="countdownBackgroundColor"
            onChange={handleChange}
            style={styles.inputStyle}
          />
          <TextField
            floatingLabelText="Countdown Text Color"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={settings.countdownTextColor}
            name="countdownTextColor"
            onChange={handleChange}
            style={styles.inputStyle}
          />
        </div>
      </div>
    )
}

export default CountDownOptions


// WEBPACK FOOTER //
// ./src/components/settings/CountDownOptions.js